import {
	Component,
	EventEmitter,
	HostListener,
	Input,
	Output
}                               from '@angular/core';
import {
	IDomTreeChangeData,
	IKeyValueMap,
	IScrollData
}                               from '@core/interfaces/common.interfaces';
import { ScrollEventDirective } from '@shared/directives/scroll-event.directive';

@Component( {
	selector: 'app-modal-base-scrollable-content',
	templateUrl: './modal-base-scrollable-content.component.html',
	styleUrls: [ './modal-base-scrollable-content.component.scss' ],
	providers: [
		ScrollEventDirective
	]
} )
export class ModalBaseScrollableContentComponent {

	private _resizeEventTimeout: ReturnType<typeof setTimeout>;
	private _lastScrollData: IScrollData;

	@Input() renderPageHeader = false;
	@Input() pageHeaderStyleClassOverwrite = 'px-3 ps-lg-4 pe-4';
	@Input() pageHeaderWrapperStyleClassOverwrite = 'pb-2';
	@Input() pageHeaderTitle = '';
	@Input() pageHeaderShowBackNav: boolean;
	@Output() pageHeaderNavigateBackEmitter: EventEmitter<null> = new EventEmitter();
	@Input() scrollableContentHeight = 'height-75vh';
	@Input() scrollableContentContainerStyleNgClassMap: IKeyValueMap<boolean>;
	@Input() scrollableContentWrapperStyleClassOverwrite = 'px-3 ps-lg-4';
	@Input() scrollableContentWrapperStyleNgClassMap: IKeyValueMap<boolean>;
	@Input() autoFitScrollableContentHeight: boolean;


	isOverflownX: boolean;
	isOverflownY: boolean;
	isScrolled: boolean;

	constructor( private scrollEventDirective: ScrollEventDirective ) {}

	@HostListener( 'window:resize', [ '$event' ] )
	onResize() {
		if ( this._resizeEventTimeout ) {
			clearTimeout( this._resizeEventTimeout );
		}

		this._resizeEventTimeout = setTimeout( () => {
			clearTimeout( this._resizeEventTimeout );
			const scrollData = this.scrollEventDirective.updateScrollData( this._lastScrollData.target );
			this.onScroll( scrollData );
		}, 200 );
	}

	private isOverflown( scrollData: IScrollData ): void {
		this.isOverflownX = scrollData.scrollWidth > scrollData.clientWidth;
		this.isOverflownY = scrollData.scrollHeight > scrollData.clientHeight;
	}

	onScroll( scrollData: IScrollData ): void {
		this.isOverflown( scrollData );
		let stickyContentStyle = this.scrollableContentWrapperStyleClassOverwrite;
		stickyContentStyle += this.isOverflownX ? ' isOverflownX' : '';
		stickyContentStyle += this.isOverflownY ? ' isOverflownY' : '';
		this.scrollableContentWrapperStyleClassOverwrite = stickyContentStyle;

		if ( this.autoFitScrollableContentHeight && scrollData.targetFitMaxHeight ) {
			scrollData.target.style.maxHeight = `${ scrollData.targetFitMaxHeight }px`;
		}

		this._lastScrollData = scrollData;

		const timeout = setTimeout( () => {
			clearTimeout( timeout );
			this.isScrolled = this.isOverflownY && scrollData.scrollTop > 0;
		}, 0 );
	}

	onScrollableContentChange( domTreeChangeData: IDomTreeChangeData ): void {
		const scrollData = this.scrollEventDirective.updateScrollData( domTreeChangeData.element );
		if ( scrollData ) {
			this.onScroll( scrollData );
		}
	}
}
